import { Component, OnInit } from '@angular/core';
import { DeviceTypeService} from '../services/device-type.service';
import { ProtocolService} from '../services/protocol.service';
import { Message} from 'primeng/primeng';
import { ConfirmationService} from 'primeng/primeng';
import { SelectItem} from 'primeng/primeng';

@Component({
  selector: 'app-device-type',
  templateUrl: './device-type.component.html',
  styleUrls: ['./device-type.component.css'],
  providers: [ConfirmationService]
})
export class DeviceTypeComponent implements OnInit {

  msgs: Message[] = [];
  deviceType: any;
  deviceTypes : any [];
  protocols:SelectItem[];
  displayAdd: boolean = false;
  displayEdit: boolean = false;
  status: SelectItem[];
  blockedDocument: boolean = false;

  constructor(private deviceTypeService : DeviceTypeService,private protocolService : ProtocolService
    ,private confirmationService: ConfirmationService) { }

  ngOnInit() {
    this.init();
    this.status = [
            {label: 'Habilitado', value: 'H', icon: 'fa fa-check-square-o'},
            {label: 'Inhabilitado', value: 'I', icon: 'fa fa-square-o'}
        ];
  }
  init(){
    this.deviceTypes = [];
    this.deviceTypeService.findAll().then(data => {
      let response: any = data;
      response.deviceTypes.forEach(item => {
        this.deviceTypes.push(item);
      });
    }).catch(err =>{
        this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
    });

    this.protocols = [];
    this.protocolService.findAll().then(data => {
      let response: any = data;
      response.protocols.forEach(item => {
        this.protocols.push({label: item.name, value: item.idProtocol});
      });
    }).catch(err =>{
        this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
    });

    this.deviceType = {status:"H"};
    this.displayAdd = false;
    this.displayEdit = false;
  }

  showAdd(){
    this.displayAdd = true;
  }

  showEdit(deviceType:any){
    this.deviceType=deviceType;
    this.displayEdit = true;
  }

  hide(){
    this.deviceType = {status:"H"};
    this.displayAdd = false;
    this.displayEdit = false;
  }

  add(){
    this.blockedDocument = true;
    this.deviceTypeService.create(this.deviceType).then(data =>{
      let response: any = data;
        if(response.status == 'OK'){
          this.init();
          this.msgs = [{severity:'info', summary:'INFO', detail:'Registro insertado exitosamente'}];
        }else{
          this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
        }
        this.blockedDocument = false;
    }).catch(err =>{
        this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
        this.blockedDocument = false;
    });
  }

  edit(){
    this.blockedDocument = true;
    this.deviceTypeService.edit(this.deviceType).then(data =>{
      let response: any = data;
        if(response.status == 'OK'){
          this.init();
          this.msgs = [{severity:'info', summary:'INFO', detail:'Registro modificado exitosamente'}];
        }else{
          this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
        }
        this.blockedDocument = false;
    }).catch(err =>{
        this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
        this.blockedDocument = false;
    });
  }

  del(id: number){
    this.confirmationService.confirm({
            message: 'Esta seguro de eliminar el registro seleccionado?',
            header: 'Confirmación',
            icon: 'fa fa-trash',
            accept: () => {
                this.blockedDocument = true;
                this.deviceTypeService.remove(id).then(data =>{
                  let response: any = data;
                    if(response.status == 'OK'){
                      this.init();
                      this.msgs = [{severity:'info', summary:'INFO', detail:'Registro eliminado exitosamente'}];
                    }else{
                      this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
                    }
                    this.blockedDocument = false;
                }).catch(err =>{
                    this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
                    this.blockedDocument = false;
                });
            }
        });
  }
}



// WEBPACK FOOTER //
// ./src/app/device-type/device-type.component.ts